module.exports = __webpack_public_path__ + "images/landing/video-previews/Animatron_Product_Demo_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Animatron_Product_Demo_2x.jpg
// module id = AYrr
// module chunks = 1